import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SystemConfig } from 'src/app/client-api.service';
import { SystemConfigService } from 'src/app/core-services/system-config.service';
import { MaintenanceService } from '../services/maintenance.service';

@Component({
  selector: 'app-system-config',
  templateUrl: './system-config.component.html',
  styleUrls: ['./system-config.component.scss'  ]
})
export class SystemConfigComponent implements OnInit {

  currentYeat = '1999';
   state: 'initializing' | 'loading' | 'ready' | 'saving';  

  systemConfig$ = this.systemConfigService.systemConfig$;

  systemConfigFormGroup = new FormGroup({
    id: new FormControl(0, { nonNullable: true }),    
    actBudLedgerName: new FormControl('', { nonNullable: true, validators: Validators.required }),    
    budgetYear: new FormControl(0, { nonNullable: true, validators: Validators.required }),
    defaultCalculationView: new FormControl('', { nonNullable: true, validators: Validators.required }),
    fpLedgerName: new FormControl('', { nonNullable: true, validators: Validators.required }),
    payrollCashPayDaysPerMonth: new FormControl('', { nonNullable: true, validators: Validators.required }),
    payrollExemptSalaryThreshold: new FormControl(0, { nonNullable: true, validators: Validators.required }),
    payrollSplitAccounts: new FormControl('', { nonNullable: true, validators: Validators.required }),
    specialAccountsGainLossToLease: new FormControl('', { nonNullable: true, validators: Validators.required }),
    specialAccountsGpr: new FormControl('', { nonNullable: true, validators: Validators.required }),
    specialAccountsVacancyLoss: new FormControl('', { nonNullable: true, validators: Validators.required })
  });

  constructor(private maintenanceService: MaintenanceService,
              private systemConfigService: SystemConfigService
  ) {     
    this.state = 'initializing';
  }

  ngOnInit(): void {
     this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.getSystemConfig();
  }

  getSystemConfig() {
    this.state = 'loading';
    this.systemConfig$.pipe(
      map((sc) => {
        this.systemConfigFormGroup.patchValue({            
              id: sc!.id,
              actBudLedgerName: sc!.actBudLedgerName,
              budgetYear: sc!.budgetYear,
              defaultCalculationView: sc!.defaultCalculationView,
              fpLedgerName: sc!.fpLedgerName,
              payrollCashPayDaysPerMonth: sc!.payrollCashPayDaysPerMonth,
              payrollExemptSalaryThreshold: sc!.payrollExemptSalaryThreshold,
              payrollSplitAccounts: sc!.payrollSplitAccounts,
              specialAccountsGainLossToLease: sc!.specialAccountsGainLossToLease,
              specialAccountsGpr: sc!.specialAccountsGpr,
              specialAccountsVacancyLoss: sc!.specialAccountsVacancyLoss
            });
      }),
      tap(() => this.state = 'ready')
    ).subscribe();
  }

  onSubmit() {

    const systemConfig: SystemConfig = this.systemConfigFormGroup.getRawValue();
  
    this.systemConfigService.updateSystemConfig(systemConfig)
      .pipe(
        catchError(() => {
          alert('Error saving System Config');
          return EMPTY;
        }),
        tap(() => this.systemConfigService.setSystemConfig()),
        tap(() => {
          alert('When saving system configuration data, the browser will automatically perform a hard refresh to ensure the updated data are loaded.');
          this.triggerHardRefresh();
        })
      )
      .subscribe();
  }

  triggerHardRefresh() {
    window.location.href = window.location.href;
  }
}
